import { Header } from '../../components/Shared/NavBar/Header.jsx';
import { Complain } from '../../components/Client/Complain.jsx';
export const ComplainView = () => {
  return (
    <>
      <Header />
      <Complain/>
    </>
  );
};
